<!--<template>
  <div v-if="modelValue" class="simple-modal-backdrop">
    <div class="simple-modal">
      <p class="modal-text">{{ title }}</p>
      <div class="button-group">
        <button class="btn btn-primary" @click="handleChoice(option1)">
          {{ option1 }}
        </button>
        <button class="btn btn-primary" @click="handleChoice(option2)">
          {{ option2 }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleModal",
  props: {
    modelValue: { type: Boolean, required: true },
    title: { type: String, required: true },
    option1: { type: String, required: true },
    option2: { type: String, required: true }
  },
  emits: ["update:modelValue", "chose"],
  methods: {
    handleChoice(option) {
      this.$emit("chose", option);
      this.$emit("update:modelValue", false);
    }
  }
};
</script>

<style scoped>
.simple-modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.simple-modal {
  background: #fff;
  padding: 2rem;
  border-radius: 0.5rem;
  width: 90%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.2);
}

.modal-text {
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 1rem;
}
</style>
-->
<template>
  <div v-if="modelValue" class="simple-modal-backdrop">
    <div class="simple-modal">
     <p v-if="title" class="modal-text"><strong>{{ title }}</strong></p>
      <div class="modal-content">
        <slot></slot>
      </div>
      <div class="button-group">
        <button
          v-for="(btn, index) in buttons"
          :key="index"
          class="btn btn-primary"
          @click="handleChoice(btn)"
        >
          {{ btn }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleModal",
  props: {
    modelValue: { type: Boolean, required: true },
    title: { type: String, required: true },
    buttons: { type: Array, default: () => [] } 
  },
  emits: ["update:modelValue", "chose"],
  methods: {
    handleChoice(option) {
      this.$emit("chose", option);
      this.$emit("update:modelValue", false);
    }
  }
};
</script>
<style scoped>
.simple-modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.simple-modal {
  background: #fff;
  padding: 2rem;
  border-radius: 0.5rem;
  width: 95%;      /* più largo rispetto al 90% */
  max-width: 600px; /* aumenta il massimo */
  text-align: center;
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.2);
}

.modal-text {
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.modal-content p {
  font-weight: 600; /* grassetto */
  line-height: 1.4;
  font-size: 1rem;
}
</style>